class LPProductForm {
    constructor() {
      this.instanceName = "LPProductForm";
      this.skus = [];
      this.subscriptionFrequency = false;
      this.mandatorySKUs = [];
      this.wipeCart = false;
      // 'drawer' (AJAX + open iCart), 'cart' (/cart), 'checkout' (/checkout)
      this.afterAdd = 'drawer';
      this.discountCode = null;
      this.debug = false;
      this.logLevel = "info";
      this.mock = false;
      this.restrictSubscriptionToMultiplePacks = true;
      this.useSubscriptions = false;
      this.dmaSubscriptionOverride = false;
      this.isInitialized = false;
      this.moneyFormat = "${{amount}}";
      this.currency = "USD";
      this.dmaSubscriptionFrequency = "1 Month";
      this.totalPacksMemo = null;
      this.variantTotalsMemo = null;
      this.informFB = false;
      this.isSubmitting = false;
      this.log = this.createLogger();
    }
  
    createLogger() {
      const logLevels = {
        debug: 0,
        info: 1,
        warning: 3,
        success: 4,
        error: 5
        };
  
      const colors = {
        debug: "#9b59b6",
        info: "#3498db",
        success: "#2ecc71",
        warning: "#f1c40f",
        error: "#e74c3c",
        };
  
      const currentLogLevel = logLevels[this.logLevel] || 0;
  
      const logFn = (type, ...args) => {
        if (this.debug && logLevels[type] >= currentLogLevel) {
          console.log(
            `%cNP-${this.instanceName}`,
            `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
            ...args
          );
        }
        };
  
      return {
        debug: (...args) => logFn("debug", ...args),
        info: (...args) => logFn("info", ...args),
        success: (...args) => logFn("success", ...args),
        warning: (...args) => logFn("warning", ...args),
        error: (...args) => logFn("error", ...args),
      };
    }
  
    init({
      wipeCart = false,
      afterAdd = 'drawer',
      debug = false,
      mock = false,
      moneyFormat = "${{amount}}",
      currency = "USD",
      informFB = false,
      restrictSubscriptionToMultiplePacks = true,
    } = {}) {
      this.wipeCart = wipeCart;
      this.afterAdd = afterAdd;
      this.debug = debug;
      this.mock = mock;
      this.dmaSubscriptionOverride = false;
      this.moneyFormat = moneyFormat;
      this.currency = currency;
      this.informFB = informFB;
      this.restrictSubscriptionToMultiplePacks = restrictSubscriptionToMultiplePacks;
      this.log.info("LPProductForm initialized", {
        wipeCart: this.wipeCart,
        afterAdd: this.afterAdd,
        debug: this.debug,
        mock: this.mock,
        moneyFormat: this.moneyFormat,
      });
  
      window.dispatchEvent(new CustomEvent("LPProductFormInit"));
  
      window.addEventListener("locGateSubsAdded", (event) => {
        this.log.warning(
          "Detected locGateSubsAdded, restricting to only subscriptions (when they exist)"
      );
        this.dmaSubscriptionOverride = true;
      });
      if (window.locGated === true) {
        this.log.warning(
          "Detected locGateSubsAdded, restricting to only subscriptions (when they exist)"
          );
        this.dmaSubscriptionOverride = true;
      }
  
      this.isInitialized = true;
    }
  
    formatMoney(cents) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = this.moneyFormat;
      function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split("."),
          dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
  
    addSKU({
      sku,
      quantity,
      name,
      price,
      compareAtPrice,
      sellingPlanId = 0,
      sellingPlanPercentOff,
      packCount = 1,
      availableSellingPlans = [],
    }) {
      const info = {
        sku,
        quantity,
        name,
        price,
        compareAtPrice,
        sellingPlanId,
        sellingPlanPercentOff,
        packCount,
        availableSellingPlans,
      };
      this.skus.push(info);
      this.log.info('SKU added', info);
    }
  
    getSKUs() {
      return this.skus;
    }
  
    setSKUs(skus) {
      this.skus = skus;
      this.skus.push(...this.mandatorySKUs);
      this.log.info("setSKUs()", this.skus);
    }
  
    getSubscriptionFrequency() {
      if (this.dmaSubscriptionOverride === true) {
        this.log.info("getSubscriptionFrequency() - DMA Override", "1 Month");
        return "1 Month";
      }
      this.log.info("getSubscriptionFrequency()", this.subscriptionFrequency);
      return this.subscriptionFrequency;
    }
  
    setSubscriptionFrequency(subscriptionFrequency) {
      this.log.info("setSubscriptionFrequency()", subscriptionFrequency);
      // Normalize null/undefined/'' to false so downstream truthy checks behave consistently.
      this.subscriptionFrequency = subscriptionFrequency || false;
    }
  
    formatTotals(raw) {
      const formatted = {
        price: this.formatMoney(raw.price),
        nonSubscriptionPrice: this.formatMoney(raw.nonSubscriptionPrice),
        subscriptionPrice: this.formatMoney(raw.subscriptionPrice),
        compareAtPrice: this.formatMoney(raw.compareAtPrice),
        saved: this.formatMoney(raw.saved),
        percentageOff: raw.percentageOff,
        hasSubscriptions: raw.hasSubscriptions,
      };
  
      return formatted;
    }
  
    getRawTotals(item) {
      const raw = {};
      const totalExceeds1Pack = this.getTotalPacks() > 1;
      const subscriptionFrequency = this.getSubscriptionFrequency();
  
      raw.price = item.price * item.quantity;
      raw.compareAtPrice = (item.compareAtPrice || item.price) * item.quantity;
      raw.hasSubscriptions = false;
      raw.packCount = item.packCount || 1;
  
      if (totalExceeds1Pack === true || this.restrictSubscriptionToMultiplePacks === false) {
        let changed = false;
  
        if (
          item.availableSellingPlans &&
          item.availableSellingPlans.length > 0 &&
          subscriptionFrequency
        ) {
          this.log.debug(`getRawTotals() - Trying to find subscriptions frequency: ${subscriptionFrequency}`, item.availableSellingPlans);
          const freqStr = String(subscriptionFrequency);
          const lcFrequency = freqStr.toLowerCase();
          const frequency = item.availableSellingPlans.find((plan) => {
            const planName = String(plan.name || '').toLowerCase();
            return String(plan.id) === freqStr ||
              planName === lcFrequency ||
              planName === `every ${lcFrequency}` ||
              // Prefer exact-ish matches; avoid short ambiguous includes
              (lcFrequency.length >= 5 && planName.includes(lcFrequency));
          });
          if (frequency) {
            this.log.debug(
              `Found subscription frequency ${subscriptionFrequency} in available selling plans for ${item.name}`
            );
            item.sellingPlanId = frequency.id;
            item.sellingPlanPercentOff = frequency.percentOff;
  
            raw.hasSubscriptions = true;
            raw.nonSubscriptionPrice = raw.price;
            raw.price = raw.price * (1 - item.sellingPlanPercentOff / 100);
            raw.subscriptionPrice = raw.price;
  
            changed = true;
          }
        }
        if (changed === false && subscriptionFrequency && item.sellingPlanId && item.sellingPlanPercentOff) {
          raw.hasSubscriptions = true;
          raw.nonSubscriptionPrice = raw.price;
          raw.price = raw.price * (1 - item.sellingPlanPercentOff / 100);
          raw.subscriptionPrice = raw.price;
          changed = true;
        }
        if (changed === false) {
          delete item.sellingPlanId;
          delete item.sellingPlanPercentOff;
        }
      }
  
      raw.saved = (raw.compareAtPrice - raw.price) * item.quantity;
      raw.percentageOff = Math.floor((raw.saved / raw.compareAtPrice) * 100);
  
      return raw;
    }
  
    getTotalPacks() {
      const skuHash = JSON.stringify(
        this.skus.map((item) => ({
          sku: item.sku,
          quantity: item.quantity,
          packCount: item.packCount,
        }))
      );
  
      if (this.totalPacksMemo && this.totalPacksMemo[skuHash]) {
        this.log.debug(
          "getTotalPacks() using memoized result, total packs =",
          this.totalPacksMemo[skuHash]
        );
        return this.totalPacksMemo[skuHash];
      }
      const totalPacks = this.skus.reduce(
        (sum, item) => sum + (parseInt(item.packCount || 1) * item.quantity),
        0
      );
  
      if (!this.totalPacksMemo) {
        this.totalPacksMemo = {};
      }
      this.totalPacksMemo[skuHash] = totalPacks;
  
      return totalPacks;
    }
  
    getTotal() {
      const total = this.skus.reduce(
        (acc, item) => {
          const raw = this.getRawTotals(item);
          acc.price += raw.price;
          acc.compareAtPrice += raw.compareAtPrice;
          acc.saved += raw.saved;
  
          if (raw.hasSubscriptions === true) {
            acc.subscriptionPrice += raw.subscriptionPrice;
          }
          acc.nonSubscriptionPrice += raw.nonSubscriptionPrice;
  
          acc.percentageOff = Math.floor((acc.saved / acc.compareAtPrice) * 100);
          acc.hasSubscriptions =
            acc.hasSubscriptions || raw.hasSubscriptions || false;
          acc.packs = acc.packs + parseInt(raw.packCount || 1);
  
          return acc;
      },
        {
          price: 0,
          compareAtPrice: 0,
          saved: 0,
          percentageOff: 0,
          subscriptionPrice: 0,
          nonSubscriptionPrice: 0,
          packs: 0,
          hasSubscriptions: false,
        }
      );
  
      const percentageOff = Math.floor(
        (total.saved / total.compareAtPrice) * 100
      );
      this.log.debug(total, percentageOff);
  
      const formatted = this.formatTotals(total);
  
      if (total.subscriptionPrice) {
        formatted.subscriptionPrice = this.formatMoney(total.subscriptionPrice);
      }
  
      const result = {
        total,
        formatted,
        hasSubscriptions: total.hasSubscriptions,
      };
  
      this.log.info("getTotal()", result);
      return result;
    }
  
    getVariantTotals(item) {
      const memoKey = `${item.sku}-${item.quantity}-${item.price}-${item.compareAtPrice}-${item.sellingPlanPercentOff}-${this.useSubscriptions}-${this.dmaSubscriptionOverride}-${this.getSubscriptionFrequency()}`;
  
      if (this.variantTotalsMemo && this.variantTotalsMemo[memoKey]) {
        this.log.debug("getVariantTotals() using memoized result", memoKey);
        return this.variantTotalsMemo[memoKey];
      }
  
      const raw = this.getRawTotals(item);
      const formatted = this.formatTotals(raw);
  
      this.log.debug("Available Selling Plans", item.availableSellingPlans);
  
      if (item.packCount) {
        raw.pricePerPack = raw.price / item.packCount;
        formatted.pricePerPack = this.formatMoney(raw.pricePerPack);
        this.log.error("pricePerPack", memoKey, item, raw, formatted, raw.pricePerPack, formatted.pricePerPack);
      }
  
      const result = {
        raw,
        formatted,
      };
  
      if (!this.variantTotalsMemo) {
        this.variantTotalsMemo = {};
      }
      this.variantTotalsMemo[memoKey] = result;
  
      return result;
    }
  
    addMandatorySKUs(skus) {
      this.log.debug(
        "Mandatory SKUs added:",
        skus,
        "Existing:",
        this.mandatorySKUs
      );
      this.mandatorySKUs.push(...skus);
    }
  
    setDiscountCode(code) {
      this.discountCode = code;
      this.log.debug(`Discount code set: ${code}`);
    }
  
    letFBKnow() {
      if (this.informFB === false) {
        return;
      }
      this.log.info("Letting FB know…");
  
      const totals = this.getTotal();
  
      const fbq_data = {
        content_name: this.skus[0].name,
        content_ids: this.skus.reduce((acc, item) => acc.concat(item.sku), []),
        content_type: "product_group",
        value: totals.total.price,
        currency: this.currency,
      };
      console.log(["fbq_data", fbq_data]);
  
      if (fbq) {
        fbq("track", "AddToCart", fbq_data);
        fbq("track", "InitiateCheckout", fbq_data);
      }
    }
  
    setSubmitLoading(isLoading) {
      document.querySelectorAll(".lpfp-submit").forEach((btn) => {
        if (isLoading) {
          if (!btn.dataset.originalText) {
            btn.dataset.originalText = (btn.textContent || "").trim() || "Add to Cart";
          }
          btn.classList.add("lpfp-submit--loading");
          btn.setAttribute("aria-busy", "true");
          btn.innerHTML =
            '<span class="lpfp-submit__spinner" aria-hidden="true"></span>' +
            "<span>Processing...</span>";
        } else {
          btn.classList.remove("lpfp-submit--loading");
          btn.removeAttribute("aria-busy");
          btn.textContent = btn.dataset.originalText || "Add to Cart";
        }
      });
    }

    async submitCart() {
      this.log.info("addToCart()", this.skus, "afterAdd:", this.afterAdd);

      if (this.isSubmitting) {
        this.log.warning("Submit already in progress, ignoring duplicate click");
        return;
      }
      this.isSubmitting = true;
      this.setSubmitLoading(true);

      try {
        if (this.wipeCart === true) {
          this.log.debug("Wiping cart");

          if (this.mock) {
            this.log.warning("MOCK: Wiping cart before new cart submission");
          } else {
            try {
              const response = await fetch("/cart/clear.js", { method: "POST" });
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              this.log.success("Cart cleared successfully");
            } catch (error) {
              this.log.error("Error clearing cart:", error);
            }
          }
        }

        this.letFBKnow();

        if (this.afterAdd === "drawer") {
          await this.submitCartAjax();
          this.isSubmitting = false;
          this.setSubmitLoading(false);
          return;
        }

        // Form submit navigates away — keep loading state visible
        return this.submitCartForm();
      } catch (error) {
        this.log.error("Error submitting cart:", error);
        this.isSubmitting = false;
        this.setSubmitLoading(false);
      }
    }

    async submitCartAjax() {
      const tierConfig = window.TIERED_CART_ACTIVE_CONFIG || null;
      const payload = {
        items: this.skus.map((item) => {
          const data = { id: item.sku, quantity: item.quantity };
          if (item.sellingPlanId) data.selling_plan = item.sellingPlanId;
          if (tierConfig) data.properties = { _bf_product: 'true', _tier_config: tierConfig };
          return data;
        }),
      };

      if (this.mock) {
        this.log.warning("MOCK: AJAX POST /cart/add.js", payload);
        return;
      }

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          let detail = '';
          try {
            const errBody = await response.json();
            detail = errBody.description || errBody.message || JSON.stringify(errBody);
          } catch (_) {
            /* ignore parse errors */
          }
          throw new Error(detail ? `HTTP ${response.status}: ${detail}` : `HTTP ${response.status}`);
        }
        await response.json();
        this.log.success("Added to cart via AJAX");
      } catch (error) {
        this.log.error("Error adding to cart:", error);
        return;
      }

      // Open the iCart drawer
      if (typeof window.prepareDataForDisplayWidgetByRule === "function") {
        this.log.info("Opening iCart drawer");
        window.prepareDataForDisplayWidgetByRule();
      } else {
        this.log.warning("iCart drawer not available, reloading page");
        window.location.reload();
      }
    }

    submitCartForm() {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "/cart/add";

      this.skus.forEach((item, index) => {
        const skuInput = document.createElement("input");
        skuInput.type = "hidden";
        skuInput.name = `items[${index}][id]`;
        skuInput.value = item.sku;
        form.appendChild(skuInput);

        const qtyInput = document.createElement("input");
        qtyInput.type = "hidden";
        qtyInput.name = `items[${index}][quantity]`;
        qtyInput.value = item.quantity;
        form.appendChild(qtyInput);

        if (item.sellingPlanId) {
          const sellingPlanInput = document.createElement("input");
          sellingPlanInput.type = "hidden";
          sellingPlanInput.name = `items[${index}][selling_plan]`;
          sellingPlanInput.value = item.sellingPlanId;
          form.appendChild(sellingPlanInput);
        }

        const tierConfig = window.TIERED_CART_ACTIVE_CONFIG || null;
        if (tierConfig) {
          const bfInput = document.createElement("input");
          bfInput.type = "hidden";
          bfInput.name = `items[${index}][properties][_bf_product]`;
          bfInput.value = "true";
          form.appendChild(bfInput);

          const tierInput = document.createElement("input");
          tierInput.type = "hidden";
          tierInput.name = `items[${index}][properties][_tier_config]`;
          tierInput.value = tierConfig;
          form.appendChild(tierInput);
        }
      });

      if (this.currency) {
        const currencyInput = document.createElement("input");
        currencyInput.type = "hidden";
        currencyInput.name = "currency";
        currencyInput.value = this.currency;
        form.appendChild(currencyInput);
      }

      if (this.discountCode) {
        const discountInput = document.createElement("input");
        discountInput.type = "hidden";
        discountInput.name = "discount";
        discountInput.value = this.discountCode;
        form.appendChild(discountInput);
      }

      if (this.afterAdd === 'checkout') {
        const checkoutTypeInput = document.createElement("input");
        checkoutTypeInput.type = "hidden";
        checkoutTypeInput.name = "return_to";
        checkoutTypeInput.value = "/checkout/";
        form.appendChild(checkoutTypeInput);
      }

      document.body.appendChild(form);
      const formData = new FormData(form);
      this.log.info("Submitting cart form", ...formData);

      if (this.mock) {
        this.log.warning("MOCK: Submitting form to:", form.action);
        return;
      }

      form.submit();
    }
  }
  
  window.LPProductForm = new LPProductForm();
  